import MyPage from '@/Pages/MyPage';

const MyPageRoutes = [
  {
    breadcrumb: [{ path: '/mypage', breadcrumbName: 'MyPage Module' }],
    Component: MyPage,
  },
];

export default MyPageRoutes;
